import { twMerge } from '@troon/tailwind-preset/merge';
import type { ParentProps } from 'solid-js';

export function Page(props: ParentProps<{ class?: string }>) {
	return <div class={twMerge('flex flex-col gap-16 py-8 md:gap-24', props.class)}>{props.children}</div>;
}
